import { useState, useEffect } from 'react';
import useSWR from 'swr';
import Cookies from 'js-cookie';

import { IRepository } from '@/types';
import { IResponseError } from '@/lib/apiBase';
import { fetchRepositoryBranches, IRepositoryBranch, IRepositoryBranchesResponse } from '@/lib/repositoryBranchesApi';

interface useRepositoryBranchesParams {
  repository: IRepository;
  initialData?: IRepositoryBranchesResponse | undefined;
}

const useRepositoryBranches = ({
  repository,
  initialData, // onProgress,
}: useRepositoryBranchesParams) => {
  const token = Cookies.get('oxen_user_token');

  const [status, setStatus] = useState<'success' | 'error' | 'pending'>('pending');
  const [branches, setBranches] = useState<IRepositoryBranch[]>(initialData?.branches || []);
  const [error, setError] = useState<IResponseError | undefined>();

  const fetchKey = ['branches', repository.namespace, repository.name];

  const { data, isLoading, isValidating } = useSWR(
    fetchKey,
    () => fetchRepositoryBranches(repository.namespace, repository.name, token),
    {
      fallbackData: initialData,
      keepPreviousData: true,
      revalidateOnFocus: false,
      revalidateOnMount: !initialData,
      revalidateOnReconnect: false,
    },
  );

  // console.log('useRepositoryBranches > data', data);

  useEffect(() => {
    if (data) {
      setBranches(data.branches || []);
      setStatus(data?.status);
      setError(data?.error as IResponseError);
    }
  }, [data]);

  return {
    status: status,
    isLoading: isLoading,
    isValidating: isValidating,
    branches: branches,
    error: error,
  };
};

export default useRepositoryBranches;
